import { Box, Divider, Tab, Tabs, useTheme } from "@mui/material";

import { hexToRgba } from "@aclymatepackages/converters";

const PageTabs = ({ tabs, value, onChange }) => {
  const { palette } = useTheme();

  return (
    <Box
      position="sticky"
      top={0}
      style={{ backgroundColor: "white" }}
      zIndex={10}
    >
      <Box
        style={{ backgroundColor: hexToRgba(palette.primary.light, 0.08) }}
        width="100%"
        display="flex"
        justifyContent="center"
      >
        <Box sx={{ display: "inline-flex", flexDirection: "column" }}>
          <Tabs
            value={value}
            onChange={onChange}
            variant="scrollable"
            scrollButtons="auto"
          >
            {tabs.map(({ value: tabValue, label }) => (
              <Tab key={tabValue} value={tabValue} label={label} />
            ))}
          </Tabs>
        </Box>
      </Box>
      <Divider width="100%" />
    </Box>
  );
};
export default PageTabs;
